export function Logo({ size = "md" }) {
  const dims = size === "sm" ? { box: 22, text: "text-[15px]" }
             : size === "lg" ? { box: 34, text: "text-2xl" }
             : { box: 26, text: "text-lg" };
  return (
    <div className="flex items-center gap-2.5 select-none">
      <div
        className="relative flex items-center justify-center border border-black overflow-hidden"
        style={{ width: dims.box, height: dims.box, borderRadius: 6, background: "#0e0fed" }}
      >
        <span
          className="absolute rounded-full border border-black"
          style={{ width: dims.box * 0.5, height: dims.box * 0.5, background: "#8bf0ba", top: dims.box * 0.15, left: dims.box * 0.15 }}
        />
      </div>
      <span className={`font-bold tracking-tight text-ink whitespace-nowrap ${dims.text}`}>
        Ministry <span className="text-muted font-medium">of</span> Exchange
      </span>
    </div>
  );
}

export default Logo;
